import React from "react";
import { motion } from "framer-motion";

/**
 * Replaces the old circular “BUILD A SUCCESS” badge on About + Services showcase.
 * Animated purple ball + sparkle star.
 */
function ShowcaseDecoAnim() {
  return (
    <div className="showcase-deco-anim" aria-hidden>
      <motion.span
        className="showcase-deco-ball"
        animate={{
          y: [0, -12, 0],
          scale: [1, 1.06, 1],
        }}
        transition={{
          duration: 3.2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.span
        className="showcase-deco-star"
        animate={{
          rotate: [0, 18, -12, 0],
          scale: [1, 1.12, 1],
        }}
        transition={{
          duration: 4.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        ✦
      </motion.span>
    </div>
  );
}

export default ShowcaseDecoAnim;
